module.exports = __webpack_public_path__ + "static/media/VN.1205e72f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/VN.svg
// module id = 390
// module chunks = 0